import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { selectCurrentUser } from "../../../store/selectors/authSelectors";
import { useLazyGetBrandAndIndustryIdsForAdvertiserQuery } from "../../../api/projectsApi";
import {
  selectAllBrandsFromCache,
  selectAllIndustriesFromCache,
  selectSelectedAdvertiser,
} from "../../../store/selectors/deliveryWizardSelector";
import {
  setSelectedBrand,
  setSelectedIndustry,
} from "../../../store/slices/deliveryWizardSlice";
import { BrandT, IndustryT, SelectOptionT } from "../../../models/models";
import { selectCurrentLang } from "../../../store/selectors/appSelectors";
import { LangE } from "../../../models/enums";
import { useSelectOptions } from "./useSelectOptions";

const NO_MARKET_CATEGORY_VALUE = 1;

/**
 *
 * Implementing of the JMMEDIAT-627 task.
 *
 * It autopopulates brand and market category fields
 * in the campaign wizard via redux store
 * with the values, fetched from the server
 *
 */

const useLastBrandAndIndustryIds = () => {
  const dispatch = useAppDispatch();
  const lang = useAppSelector(selectCurrentLang);
  const advertiser = useAppSelector(selectSelectedAdvertiser);
  const { brandsSO, industrySO } = useSelectOptions();
  const user = useAppSelector(selectCurrentUser);
  const [getBrandAndIndustryIds] =
    useLazyGetBrandAndIndustryIdsForAdvertiserQuery();

  useEffect(() => {
    if (user?.id && advertiser?.value) {
      const payload = {
        clientId: user.id,
        advertiserId: advertiser.value,
      };

      getBrandAndIndustryIds(payload).then((res) => {
        if ("data" in res) {
          if (brandsSO) {
            const foundBrand = brandsSO.find(
              (brand) => +brand.value === res.data.BrandId
            );
            if (foundBrand) {
              dispatch(setSelectedBrand(foundBrand));
            }
          }
          // set industry only if the last value wasn't "No market category"
          if (industrySO && res.data.IndustryId !== NO_MARKET_CATEGORY_VALUE) {
            const foundIndustry = industrySO.find(
              (industry) => +industry.value === res.data.IndustryId
            );
            if (foundIndustry) {
              dispatch(setSelectedIndustry(foundIndustry));
            }
          }
        }
      });
    }
  }, [
    user?.id,
    advertiser?.value,
    getBrandAndIndustryIds,
    brandsSO?.length,
    industrySO?.length,
    dispatch,
    lang,
  ]);
};

export default useLastBrandAndIndustryIds;
